let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("i7Fm9")).then(() => parcelRequire('dDRuh'));